import loc from "owa-localize";
import { goToMailCommand, goToCalendarCommand, goToHostedAppCommand, goToDevToolsCommand, goToEdgeTracingToolsCommand, jumpFocus, } from "./AppModuleHotKeys.locstring.json";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import type { HotkeyCommand, Hotkeys } from "owa-hotkeys";
import type { ResourceId } from "owa-localize";
import { F6_HOTKEY_COMMANDS } from "owa-accessibility-loop-nav/lib/utils/f6HotkeysCommands";
import { getApplicationSettings } from "owa-application-settings";

export const GoToCategory = "goTo";

export function getAppModuleCommands(): {
    [index: string]: HotkeyCommand;
} {
    const disableAppModuleCommands = getApplicationSettings("Hotkeys").disableAppModuleCommands;
    
    const commands: {
        [index: string]: HotkeyCommand;
    } = disableAppModuleCommands
        ? {}
        : {
            gotoMail: createHotkey(goToMailCommand, "ctrl+alt+1", "ctrl+1"),
            gotoCalendar: createHotkey(goToCalendarCommand, "ctrl+alt+2", "ctrl+2"),
            gotoHostedApp: createHotkey(goToHostedAppCommand, [
                "ctrl+alt+3",
                "ctrl+alt+4",
                "ctrl+alt+5",
                "ctrl+alt+6",
                "ctrl+alt+7",
                "ctrl+alt+8",
                "ctrl+alt+9",
            ], ["ctrl+3", "ctrl+4", "ctrl+5", "ctrl+6", "ctrl+7", "ctrl+8", "ctrl+9"]),
        };
    
    if (isGlobalFeatureEnabled("fwk-customDevToolsHotKeys")) {
        commands.goToDevTools = createHotkey(goToDevToolsCommand, "ctrl+shift+d", "ctrl+shift+d");
        commands.goToEdgeTracingTools = createHotkey(goToEdgeTracingToolsCommand, "ctrl+shift+t", "ctrl+shift+t");
    }
    
    return commands;
}

export function getF6Hotkeys(): {
    [index: string]: HotkeyCommand;
} {
    const commands: {
        [index: string]: HotkeyCommand;
    } = {
        f6: wrapF6Hotkeys(F6_HOTKEY_COMMANDS.f6),
        shiftF6: wrapF6Hotkeys(F6_HOTKEY_COMMANDS.shiftF6),
        ctrlTab: wrapF6Hotkeys(F6_HOTKEY_COMMANDS.ctrlTab),
        ctrlShiftTab: wrapF6Hotkeys(F6_HOTKEY_COMMANDS.ctrlShiftTab),
    };
    return commands;
}

function wrapF6Hotkeys(hotkey: HotkeyCommand) {
    return {
        ...hotkey,
        category: GoToCategory,
        description: loc(jumpFocus),
    };
}

function createHotkey(descriptionResourceId: ResourceId, hotkey: Hotkeys, outlookHotkey: Hotkeys): HotkeyCommand {
    return {
        category: GoToCategory,
        description: loc(descriptionResourceId),
        hotmail: hotkey,
        yahoo: hotkey,
        gmail: hotkey,
        owa: hotkey,
        outlook: outlookHotkey,
    };
}
